import { apiClient } from '@/lib/api'

class EmailService {
  async sendPosUserTestEmail(system: string, email: string): Promise<void> {
    await apiClient.post(
      `/core/v5/email/admin/${encodeURIComponent(system)}/district-manager-test/${encodeURIComponent(email)}`
    )
  }
}

export const emailService = new EmailService()
